module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aW5kw"))).then(() => parcelRequire('cvs7o'));